import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { UserEnquiryService } from "../../Services/EnquiryServices";

export const EnquiryView = () => {
  const [singleenquiry, setSingleenquiry] = useState([]);
  const history = useHistory();
  const singleId = history.location.search;

  const getData = async () => {
    let id = singleId.split("=");
    let obj = { id: id[1] };
    await UserEnquiryService.getSingalEnquiry(obj)
      .then((res) => {
        setSingleenquiry(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="input-group pl-3 w-25"></div>
            </div>
            <div className="mb-2">
              <div className="d-flex justify-content-between">
                <div>
                  {" "}
                  <h6>
                    Name :- <span>{singleenquiry[0]?.name}</span>
                  </h6>
                </div>
                <div className="text-end">
                  <h6>
                    Email :- <span>{singleenquiry[0]?.email}</span>
                  </h6>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div>
                  <h6>
                    Contect no. :-{" "}
                    <span>{singleenquiry[0]?.contact_number}</span>
                  </h6>
                </div>
                <div className="text-end">
                  <h6>
                    Address :- <span>{singleenquiry[0]?.address}</span>
                  </h6>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                  <div>
                  <h6>
                  Comment/Remark :- <span>{singleenquiry[0]?.comment}</span>
                  </h6>
                  </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Product Name</th>
                    <th>Retailer Name</th>
                    <th>Product No.</th>
                    <th>Refferal/Promo Code</th>
                    <th>quantity</th>
                    <th>Value of Items</th>
                    {/* <th>Address</th> */}
                  </tr>
                </thead>
                <tbody>
                  {singleenquiry[0]?.enquiry_item &&
                    singleenquiry[0].enquiry_item.map((item, key) => (
                      <tr>
                        <td className="text-body fw-bold">{key + 1}</td>
                        <td>{item?.product_name || "-"}</td>
                        <td>{item?.retailer_name || "-"}</td>
                        <td>{item?.product_no || "-"}</td>
                        <td>{singleenquiry[0]?.refferal_code || "-"}</td>
                        <td>{item?.product_no || "0"}</td>
                        <td>{item?.value_of_item || "0"}</td>
                        {/* <td>{item?.retailer_address || "-"}</td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryView;
